import { IZoneServiceMock } from "./zone.types";

export const mockZoneService = (): IZoneServiceMock => ({
  getZones: jest.fn(),
});
